angular.module('app').directive('uiUpdated', [
    '$timeout',
    function($timeout) {
        return {
            restrict: 'AE',
            link: function(scope, el, attr) {
                var isFirstLoad = true;
                var updateContent =
                    attr.updateContent == 'false' ? false : true;

                attr.$observe('uiUpdated', function(newVal) {
                    if (updateContent) {
                        el[0].innerHTML = attr.uiUpdated;
                    }
                    if (isFirstLoad) {
                        isFirstLoad = !isFirstLoad;
                        return;
                    }
                    attr.$addClass('updated');
                    $timeout(function() {
                        attr.$removeClass('updated');
                    }, 4000);
                });
            },
        };
    },
]);
